const sexes = [
  {
    id: 'female',
    label: 'Female',
    group: 'other',
    icon: 'female',
  },
  {
    id: 'undefined',
    label: 'Unknown',
    group: 'other',
    icon: 'question',
  },
  {
    id: 'male',
    label: 'Male',
    group: 'other',
    icon: 'male',
  },
]

export { sexes }
